<template>
  <layout>
    <div slot="content">
      <i-card title="添加分类" contentWidth="80%">
        <div slot="content">
          <el-form :model="fields" label-width="80px" :rules="validateRules" size="small">
            <el-form-item label="分类名称" prop="sailings_title">
              <el-input v-model="fields.cate_name"></el-input>
            </el-form-item>
            <el-form-item label="排序" prop="sailings_title">
              <el-input v-model="fields.sort"></el-input>
            </el-form-item>
            <el-form-item label="首页展示" prop="sailings_title">
              <el-radio v-model="fields.is_index" :label="1">展示</el-radio>
              <el-radio v-model="fields.is_index" :label="-1">不展示</el-radio>
            </el-form-item>
            <el-form-item label="顶部图标" prop="sailings_title">
              <el-radio v-model="fields.top_icon" :label="1">是</el-radio>
              <el-radio v-model="fields.top_icon" :label="-1">否</el-radio>
            </el-form-item>
            <el-form-item label="分类图片" prop="sailings_title">
              <i-upload :maxFiles="1" v-model="fields.images"></i-upload>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" :loading="loading" @click="postCate">立即提交</el-button>
              <router-link :to="{name:'settings.cate'}">
                <el-button>返回列表</el-button>
              </router-link>
            </el-form-item>
          </el-form>
        </div>
      </i-card>
    </div>
  </layout>
</template>

<script>
import iUpload from "@/components/i-upload"

export default {
  name: "sailings",
  components: {iUpload},
  data: function () {
    return {
      loading: false,
      fields: {
        cate_name: '',
        images: [],
        image: '',
        sort: 0,
        is_index: -1,
        top_icon: -1,
      },
      validateRules: {
        cate_name: [
          {required: true, message: '分类名称不可为空'}
        ],
      },
    }
  },
  methods: {
    postCate: function () {
      this.loading = true;
      if (this.fields.images.length > 0) {
        this.fields.image = this.fields.images[0].path;
      }
      this.$http.request('addCate', this.fields).then(res => {
        this.loading = false;
        if (res.status === 'success') {
          let _self = this;
          this.$message({
            message: res.message,
            type: 'success',
            onClose: function () {
              _self.$router.back();
            }
          });
        }
      });
    },
    getCate: function () {
      let cateId = this.$route.query.cate_id;
      if (cateId) {
        this.$http.request('cateInfo', {cate_id: cateId}).then(res => {
          if (res.status === 'success') {
            this.fields = res.data;
          }
        });
      }
    }
  },
  created: function () {
    this.getCate();
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/settings/add_cate.vue